module.exports = __webpack_public_path__ + "static/media/BRASÃO_SECTI_PNG-02.b041e4a7.png";